import React, { FC, memo } from 'react';
import { M1HeadlineModule } from '~/lib/data-contract';
import styles from './m1headline.module.css';
import { useModule } from '~/templates';
import { Container } from '../container/container.component';
import { isDarkColor } from '~/themes/cms-color-helpers';
import { Typography } from '~/shared/components/typography/typography.component';

const M1Headline: FC<M1HeadlineModule> = memo((props) => {
    const {
        backgroundColor,
        horizontalAlignment,
        headline,
        subHeadline,
        subHeadlineUppercase,
        largeHeadline = false,
        spacingTop,
        spacingBottom,
        ...rest
    } = props;
    const isDarkShade = isDarkColor(backgroundColor);

    const { index } = useModule();

    const textAlign = horizontalAlignment ?? 'center';

    if (!headline) {
        return null;
    }

    return (
        <Container
            hasGutter
            style={{ backgroundColor }}
            spacingTop={spacingTop ?? 'default'}
            spacingBottom={spacingBottom ?? 'default'}
            {...rest}
        >
            <Typography
                className={largeHeadline ? styles.headlineLarge : styles.headlineRegular}
                variant="display1"
                as={index === 0 ? 'h1' : 'h2'}
                isDarkBackground={isDarkShade}
                textAlign={textAlign}
            >
                {headline}
            </Typography>
            {subHeadline && (
                <Typography
                    className={styles.subHeadline}
                    uppercase={subHeadlineUppercase}
                    variant="display5"
                    as="h3"
                    isDarkBackground={isDarkShade}
                    textAlign={textAlign}
                >
                    {subHeadline}
                </Typography>
            )}
        </Container>
    );
});

M1Headline.displayName = 'M1Headline';
export default M1Headline;
